import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  CustomSoftIcon,
  SoftwareProIcon,
  SoftwareMainIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android app development",
    description:
      "Our Android app development services cater to the diverse Android user base. We create high-performance, user-centric apps that engage your target audience. Our software developers Miami have a deep understanding of the Android platform, allowing us to design and build responsive mobile apps that meet the highest standards of performance, functionality, and user experience",
  },
  {
    icon: IphoneIcon,
    title: "Iphone app development",
    description:
      "Our developers are experts in utilizing the latest tech stack to craft responsive and user-friendly iOS apps. Our development process combines aesthetics with functionality, resulting in apps that offer a premium experience for your users. Whether you're targeting a global or niche audience, as a leading Miami software development company, we ensure that your iPhone app is visually appealing and performance-driven.",
  },
  {
    icon: GameIcon,
    title: "Game app development",
    description: (
      <>
        <Link to="https://www.tekrevol.com/game-development">
          Game app development{" "}
        </Link>
        is an area where we excel in creativity and innovation. Our game apps
        are designed to captivate users and keep them coming back for more. We
        create entertaining, engaging games that stand out in the competitive
        app market, offering unique experiences that captivate your target
        audience
      </>
    ),
  },
  {
    icon: CustomSoftIcon,
    title: "Custom Software Development",
    description: (
      <>
        As a top-ranked Miami software development company, Our{" "}
        <Link
          to="/custom-software-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          custom software development services
        </Link>{" "}
        are your key to customized solutions. We work closely with you to
        understand your unique business needs and craft software that perfectly
        aligns with your goals. We have expertise in the latest technologies and
        industry trends to ensure your software is not just functional but
        optimized for success.
      </>
    ),
  },
  {
    icon: SoftwareProIcon,
    title: "Software Product Development",
    description:
      "Transform your software product concepts into reality with our Miami software development services. We offer end-to-end software product development services, from ideation to launch. Our software developers in Miami ensure your product meets market demands and exceeds user expectations. With a keen focus on innovation, quality, and market readiness, we're your partners in product development success.",
  },
  {
    icon: SoftwareMainIcon,
    title: "Software Support and Maintenance",
    description: (
      <>
        Beyond development, we stand by your side to provide ongoing support and{" "}
        <Link to="/mobile-app-support" rel="noopener" aria-label="TekRevol">
          app maintenance
        </Link>{" "}
        . Our expert team ensures your software remains up-to-date, secure, and
        efficient. We're dedicated to preserving your software's performance,
        allowing you to focus on your core business activities while we take
        care of the technical details.
      </>
    ),
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>Our Miami Software Development Services</h2>
            <p className="impro_para">
              We offer exceptional software development services in Miami,
              customized to improve your business's digital capabilities,
              streamline operations, and drive growth in the vibrant business
              market of Miami.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
